export default{
    puntos: [],
    puntoSelec: null,
}